import { render, staticRenderFns } from "./AsAMasterCheckpointInspectionKitMenu.vue?vue&type=template&id=1b4871c1&scoped=true"
import script from "./AsAMasterCheckpointInspectionKitMenu.vue?vue&type=script&lang=js"
export * from "./AsAMasterCheckpointInspectionKitMenu.vue?vue&type=script&lang=js"
import style0 from "./AsAMasterCheckpointInspectionKitMenu.vue?vue&type=style&index=0&id=1b4871c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4871c1",
  null
  
)

export default component.exports